<template>
  <v-list
    dense
    style="padding: 2px 0 2px 0"
    :style="getContainerStyle()"
  >
    <v-list-group
      v-if="item.items && !item.ignoreItems"
      :key="item.text"
      v-model="isExpanded"
      :prepend-icon="getPrependIcon()"
      :append-icon="getAppendIcon()"
      v-show="showAndHideBasedOnPermission(item, 1)"
    >
      <template #activator>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t('menu.' + toCamelCase(item.text)) }}
          </v-list-item-title>
        </v-list-item-content>
      </template>
      <ArchNavMenu
        :item="child"
        v-for="(child, i) in item.items"
        :key="`menu-${i}`"
      />
    </v-list-group>
    <v-list-item
      v-else
      :key="item.text"
      @click="isExternalOrDialogMenu(item) ? openExternalOrDialogMenu(item) : () => {}"
      :link="isExternalOrDialogMenu(item) ? false : true"
      :to="isExternalOrDialogMenu(item) ? undefined : $parseURL(item.link)"
      v-show="showAndHideBasedOnPermission(item, 2)"
    >
      <v-list-item-action>
        <v-icon>{{ item.icon }}</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title>
          {{ $t('menu.' + toCamelCase(item.text)) }}
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import PermissionHelper from "@/permissions/PermissionHelper";
import { PermissionEnum } from "@/permissions/PermissionEnum";
import configApi from "@/services/Api-config";
import { ActionButtonEnum } from "@/permissions/ActionButtonEnum";
import StringHelper from "@/helpers/StringHelper";
import { FeatureFlagService, FeatureList } from "sentec-core-ts";
import { Api } from "@/services/Api";

// Shared cache to prevent duplicate API calls across all menu instances
const featureFlagCache = {
  fbMenuOrder: null,
  loading: null
};

export default {
  name: "ArchNavMenu",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    startLoadComp: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      fbMenuEnable: false,
      fbMenuLoading: true,
      isExpanded: this.item.expanded || false,
    };
  },
  async mounted() {
    const hotelId = this.$route.query.hotelId;

    // Check cache first
    if (featureFlagCache.fbMenuOrder !== null) {
      this.fbMenuEnable = featureFlagCache.fbMenuOrder;
      this.fbMenuLoading = false;
      return;
    }

    // Wait for any ongoing request
    if (featureFlagCache.loading) {
      await featureFlagCache.loading;
      this.fbMenuEnable = featureFlagCache.fbMenuOrder;
      this.fbMenuLoading = false;
      return;
    }

    // Make the API call and cache the promise to prevent duplicates
    const featureFlagService = new FeatureFlagService(Api, hotelId);
    featureFlagCache.loading = featureFlagService.isFeatureAvailable(FeatureList.FbMenuOrder)
      .then(result => {
        featureFlagCache.fbMenuOrder = result;
        featureFlagCache.loading = null;
        return result;
      })
      .catch(error => {
        // On error, reset cache so it can retry
        featureFlagCache.loading = null;
        throw error;
      });

    try {
      this.fbMenuEnable = await featureFlagCache.loading;
      this.fbMenuLoading = false;
    } catch (error) {
      // Handle error gracefully - default to false
      console.error("Error loading feature flag:", error);
      this.fbMenuEnable = false;
      this.fbMenuLoading = false;
    }
  },
  methods: {
    openExternalOrDialogMenu(item) {
      if (item["is-dialog-menu"]) {
        this.$emit("set-component", item.component);
        if (!this.startLoadComp) {
          this.$emit("set-start-load-comp", true);
        } else {
          this.$emit("set-visible", true);
        }
      } else {
        let urlFo = configApi.ST_WEB_FO;
        let linkExternal = item.link + "?hotelId=" + this.$route.query.hotelId;
        window.open(urlFo + linkExternal);
      }
    },

    getContainerStyle() {
      const level = this.item.level || 1;
      return {
        marginLeft: (level - 1) * 15 + "px",
        marginRight: "5px",
      };
    },
    getPrependIcon() {
      return this.isExpanded ? "mdi-chevron-up" : "mdi-chevron-down";
    },
    getAppendIcon() {
      return "";
    },
    showAndHideBasedOnPermission(item, type) {
      if (item["featureFlagCode"] && item["featureFlagCode"] === FeatureList.FbMenuOrder) {
        console.log(this.fbMenuEnable);
        return this.fbMenuEnable;
      }
      if (item["is-dialog-menu"]) {
        const hasPermission = PermissionHelper.canAccessButton(ActionButtonEnum[item["permission-enum"]]);
        if (hasPermission || !item["permission-enum"]) {
          return true;
        }
      } else if (
        !item["is-dialog-menu"] && PermissionHelper.canAccess({
          type: type == 1 ? PermissionEnum.MENU : PermissionEnum.MENU_CHILD,
          item: type === 1 ? item : item.link,
        })
      ) {
        return true;
      }
      return false;
    },
    isExternalOrDialogMenu(item) {
      return item.external || item["is-dialog-menu"];
    },

    toCamelCase(str) {
      return StringHelper.toCamelCase(str);
    }
  }
};
</script>

<style scoped>
</style>
